export default __webpack_public_path__ + "static/media/servAccount2.ecd864b7.png";